export default "__VITE_ASSET__3sMj7Ux7__"